import useCartPage from "@/viewModels/cart/useCartPage";
import { CheckoutStepsEnum } from "@/constants/enums";
import Cart from "@/components/features/cart/Cart";
import CheckoutSteps from "@/components/features/checkout/CheckoutSteps";
import CartItemsSkeleton from "@/components/features/cart/CartItemsSkeleton";
import CheckoutStepsSkeleton from "@/components/features/checkout/CheckoutStepsSkeleton";
import SEOMeta from "@/components/ui/meta/SEOMeta";

const CartPage = () => {
  const {
    cart,

    isPageInitialized,
    handleCheckoutClick,
  } = useCartPage();

  if (!isPageInitialized) {
    return (
      <div className="brand-container max-w-screen-md">
        <CheckoutStepsSkeleton />
        <CartItemsSkeleton />
      </div>
    );
  }

  return (
    <main className="brand-main pb-20">
      {/* Step */}
      <CheckoutSteps currentStep={CheckoutStepsEnum.CART} />

      <div className="brand-container max-w-screen-md flex-col">
        {/* Cart Items */}
        <Cart {...cart} />

        {/* Checkout Btn */}
        {!cart.isCartEmpty && (
          <div className="brand-fixed-panel z-fixedButton">
            <div className="brand-container w-full max-w-screen-md">
              <button
                onClick={handleCheckoutClick}
                disabled={cart.isCartEmpty || cart.isCartUpdating}
                className="btn btn-primary m-auto mb-auto w-full"
              >
                前往結帳
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Meta Tag */}
      <SEOMeta pageTitle="購物車" />
    </main>
  );
};

export default CartPage;
